import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { UserService } from '../../domain/user/user.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dottnet-email-update',
  templateUrl: 'email-update.component.html',
  styleUrls: ['email-update.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatInput,
    MatLabel,
    MatError,
    MatButton,
    MatFormField,
    TranslatePipe,
  ],
})
export class EmailUpdateComponent {
  private readonly store = inject(Store);
  private readonly userService = inject(UserService);

  readonly currentEmail = input<string>('');
  readonly showCancel = input<boolean>(true);

  readonly saved = output<string>();
  readonly cancelled = output<void>();

  emailControl = new FormControl('', {
    validators: [Validators.required, Validators.email],
    asyncValidators: [this.userService.checkMailExistenceForEdit(this.store)],
    updateOn: 'change',
  });

  constructor() {
    effect(() => {
      const email = this.currentEmail();
      if (email && !this.emailControl.value) {
        this.emailControl.setValue(email);
      }
    });
  }

  onSubmit(): void {
    if (this.emailControl.valid) {
      this.saved.emit(this.emailControl.value!);
    } else {
      this.emailControl.markAsTouched();
    }
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  setMailExistenceError(): void {
    this.emailControl.setErrors({ ...(this.emailControl.errors ?? {}), mailExistence: true });
    this.emailControl.markAsTouched();
  }
}
